import axios from 'axios'  // https://github.com/axios/axios
import _config from './plugins/config'

export function setAuth (store, router) {

  // 라우터에 인증 로직 설정
  router.beforeEach((to, from, next) => {

    // STEP 01 : 인증이 필요한지 라우터에서 meta 정보 확인
    const isNoAuth = to.matched.some(record => record.meta.noAuth)
    // console.log("[SESSION] isNoAuth = ", isNoAuth);

    // 인증 필요 없으면 PASS
    if (isNoAuth) return next()

    store.state.session.sessionDebug && console.log("[SESSION] main.js router.beforeEach : user = ", store.getters["session/userInfo"]);

    // 이미 로그인 되어 있으면 refresh 한번 해주고 패스
    if (store.getters["session/isLogin"]) {
      store.dispatch("session/TOKEN_REFRESH", {refreshType: 'default'}) // 서버 REFRESH 실행, 단 마지막 서버 REFRESH 이후 30초 이내라면 서버요청을 하지 않는다.
      return next()
    }

    // ( F5 누른경우 체크 ) 쿠키에 토큰이 있나 읽어본다
    store.commit("session/SET_TOKEN_FROM_COOKIE", 3) // 쿠키에서 토큰 읽는다.
    if (store.getters["session/isLogin"]) { // 그래서 로그인 되면 next()는 하지만 쿠키 변조 가능성을 생각하여 서버로 강제 refresh 한다.
      store.dispatch("session/TOKEN_REFRESH", {refreshType: 'force'}) // 서버 무조건 REFRESH
      return next()
    }

    // 결국 인증이 안되어 있으면 로그인으로 보낸다
    console.log("[JWT] 003 인증이 되어있지 않아 로그인 페이지로 이동합니다.")
    next({
      path: _config.LOGIN_PATH,
      query: { redirect: to.fullPath }
    })

  })

  // api(웹서버) 응답중 token이 있는경우 웹브라우져 쿠키 및 axios defaults.headers 에 설정한다.
  axios.interceptors.response.use(
    res => {
      // if (!res.data) console.log(res.data);
      if (res && res.headers && res.headers[_config.AUTH_TOKEN_NAME]) {
        const token = res.headers[_config.AUTH_TOKEN_NAME]
        store.state.session.sessionDebug && console.log("[SESSION] main.js axios.interceptors.response.RES - 수신 : 새로운 인증토큰 발급 받음 : token = ", token);
        store.commit("session/SET_TOKEN", token)
      }
      return res
    },
    err => {
      // 인증오류가 발생할 경우 로그인 페이지로 이동한다.
      // console.log(err.response.status);
      if (err.response.status === 401) {
        const tokenError = err.response && err.response.headers && err.response.headers['token-error'] || ''
        store.state.session.sessionDebug && console.log("[SESSION] main.js axios.interceptors.response.ERR - 수신 : 401 인증오류!! 로그인 페이지로 이동, token error = ", tokenError, "err.response = ", err.response);
        // this.alert("서버 오류가 발생했습니다[5]\n" + tokenError, "오류", { color: "red"})
        // alert("인증오류가 발생했습니다.\n" + tokenError)
        // const path = err.response && err.response.data && err.response.data.path
        const path = store && store.state && store.state.route && store.state.route.path || ''
        if (tokenError == "EXPIRED" && path != _config.LOGIN_PATH) {
          console.log("[세션만료]\n\n장시간 이용을 하지 않아 자동으로 로그아웃 되었습니다.");
        } else if (tokenError == "REJECT_OTHER_LOGIN") {
          alert("다른곳에서 로그인하여 자동으로 로그아웃 되었습니다");
        } else {
          alert("[JWT] 004 인증오류! 로그인으로 이동합니다.");
        }

        store.commit("session/SET_TOKEN", null) // 인증정보 삭제
        router.push(_config.LOGIN_PATH)
        // location.href = '/front/#/login';
        return
      }
      return Promise.reject(err)
    }
  );


  // 첫 로딩시
  store.commit("session/SET_TOKEN_FROM_COOKIE", 4) // 쿠키에서 토큰 읽는다.
  if (store.getters["session/isLogin"]) { // 그래서 로그인 되면 next()는 하지만 쿠키 변조 가능성을 생각하여 서버로 강제 refresh 한다.
    store.dispatch("session/TOKEN_REFRESH", {refreshType: 'force'}) // 서버 무조건 REFRESH
  }

}
